<template>
  <v-dialog
    persistent
    v-model="profileDialogChangePassword"
    :width="screenWidth + '%'"
  >
    <div class="container-dialog">
      <close-dialog-component @closeDialog="closeDialog" />
      <div class="display-flex align-items-center justify-content-center">
        <img
          width="90px"
          src="@/assets/icons/key.png"
          alt=""
        >
      </div>
      <p class="text-title mon-bold">{{ texts.profile.dialogChangePassword.textTitle }}</p>
      <div class="mt-9">
        <v-text-field
          v-model="currentPassword"
          name="password"
          :label="texts.profile.dialogChangePassword.currenPassword"
          :append-icon="bShowCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (bShowCurrentPassword = !bShowCurrentPassword)"
          :type="bShowCurrentPassword ? 'text' : 'password'"
          outlined
          clearable
          color="#000000"
          dense
          class="global-inputs mon-regular mt-5"
          :placeholder="texts.profile.dialogChangePassword.currenPassword"
          persistent-placeholder
        >
        </v-text-field>
        <v-text-field
          v-model="newPassword"
          name="password"
          :label="texts.profile.dialogChangePassword.newPassword"
          :append-icon="bShowNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (bShowNewPassword = !bShowNewPassword)"
          :type="bShowNewPassword ? 'text' : 'password'"
          outlined
          clearable
          color="#000000"
          dense
          class="global-inputs mon-regular mt-5"
          :placeholder="texts.profile.dialogChangePassword.newPassword"
          persistent-placeholder
        >
        </v-text-field>
        <v-text-field
          v-model="confirmNewPassword"
          name="password"
          :label="texts.profile.dialogChangePassword.confirmNewPassword"
          :append-icon="bShowConfirmNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="() => (bShowConfirmNewPassword = !bShowConfirmNewPassword)"
          :type="bShowConfirmNewPassword ? 'text' : 'password'"
          outlined
          clearable
          color="#000000"
          dense
          class="global-inputs mon-regular mt-5"
          :placeholder="texts.profile.dialogChangePassword.confirmNewPassword"
          persistent-placeholder
        >
        </v-text-field>
      </div>
      <div
        v-if="isResponsive"
        class="mt-6"
      >
        <v-btn
          elevation="0"
          @click="saveChanges"
          :loading="bLoading"
          class="button-primary mon-bold"
          style="width: 100%;"
        >
          {{ texts.profile.dialogChangePassword.buttonSave }}
        </v-btn>
        <v-btn
          elevation="0"
          @click="closeDialog"
          class="button-secondary mon-regular mt-5 mb-2"
          style="width: 100%;"
        >
          {{ texts.profile.dialogChangePassword.buttonCancel }}
        </v-btn>
      </div>
      <div
        v-else
        class="mt-6 display-flex align-items-center"
      >
        <v-btn
          elevation="0"
          @click="closeDialog"
          class="button-cancel mon-regular"
        >
          {{ texts.profile.dialogChangePassword.buttonCancel }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          @click="saveChanges"
          :loading="bLoading"
          class="button-save mon-bold"
        >
          {{ texts.profile.dialogChangePassword.buttonSave }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "ProfileChangePasswordLayout",
  data() {
    //VARIABLES
    return {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      bShowCurrentPassword: false,
      bShowNewPassword: false,
      bShowConfirmNewPassword: false,
      screenWidth: 0,
      texts: "",
      bLoading: false,
      isResponsive: false,
    };
  },
  beforeMount() {
    this.texts = FILE.profile[this.selectLanguage];
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 30;
      } else {
        this.screenWidth = 100;
      }
      
      if (window.innerWidth < 960) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
    closeDialog: function () {
      this.$store.commit("setProfileDialogChangePassword", false);
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmNewPassword = "";
    },
    saveChanges: function () {
      this.bLoading = true;

      const payload = {
        sCurrentPassword: this.currentPassword,
        sNewPassword: this.newPassword,
        sConfirmNewPassword: this.confirmNewPassword,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.patch(
        `${URI}/api/v1/${this.selectLanguage}/users/${this.$store.state.sUserId}/password`,
        payload,
        config
      )
        .then((response) => {
          this.bLoading = false;

          this.mixSuccess(response.data.message);
          this.closeDialog();
        })
        .catch((error) => {
          this.bLoading = false;

          this.mixError(error.response.data.message, error.response.status);
        });
    },
  },
  computed: {
    // return create contact dialog state
    profileDialogChangePassword() {
      return this.$store.state.profileDialogChangePassword;
    },
    selectLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    profileDialogChangePassword() {
      if (this.profileDialogChangePassword) {
        this.texts = FILE.profile[this.selectLanguage];
      }
    },
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.profile[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.button-cancel {
  width: 45%;
  max-height: 40px !important;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #283c4d;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  background-color: #ffffff !important;
  text-transform: initial;
}

.button-save {
  width: 45%;
  height: 40px !important;
  background: transparent linear-gradient(257deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}

.justify-content-flex-start {
  justify-content: flex-start;
}

.justify-content-flex-end {
  justify-content: flex-end;
}

.container-buttons {
  background: red;
}

.container-dialog {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  opacity: 1;
  padding: 25px;
  position: relative;
}

.text-title {
  text-align: center;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  font-size: 28px;
}

.text-description {
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
}

.button-cancel {
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #283c4d;
  border-radius: 12px;
  opacity: 1;
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  height: 45px !important;
  text-transform: initial;
  padding-left: 35px !important;
  padding-right: 35px !important;
}

.button-delete {
  height: 45px !important;
  text-transform: initial;
  background: transparent linear-gradient(257deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 13px;
  opacity: 1;
  text-align: center;
  font-size: 16px;
  letter-spacing: 0px;
  color: #283c4d;
  padding-left: 35px !important;
  padding-right: 35px !important;
}
</style>